var showAll = false;
var $filters = document.querySelector('[data-filters]');
var $filtersMore = document.querySelector('[data-filters-more]');
if ($filters && $filtersMore) {
    var moreTitle = $filtersMore.dataset.filtersMore.split(',');
    var moreTitleShort = $filtersMore.dataset.filtersMoreShorts.split(',');
    var moreIcon = $filtersMore.dataset.filtersMoreIcon.split(',');
    $filtersMore.addEventListener('click', function(event) {
        event.preventDefault();
        showAll = !showAll;
        $filters.classList.toggle('search-filters_all', showAll);
        var index = showAll ? 1 : 0;
        $filtersMore.querySelector('span:nth-child(1)').innerText = moreTitle[index];
        $filtersMore.querySelector('span:nth-child(2)').innerText = moreTitleShort[index];
        $filtersMore.querySelector('svg').setAttribute('class', "icon icon_".concat(moreIcon[index]));
        $filtersMore.querySelector('use').setAttribute('xlink:href', "#".concat(moreIcon[index]));
    });
}
